export default {
    path: '/industry',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'manufacture',
    component: () => import('./index')
};